import item from '@/api/expense/daily-expense'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  dateRange: [moment().startOf('M').format('DD-MM-YYYY'), moment().endOf('M').format('DD-MM-YYYY')]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          date_filter: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return item.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return item.store(data)
  },
  update(context, { id, data }) {
    return item.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await item.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return item.destroy(id)
  },

  getCurrency(context) {
    return item.currency()
  },
  getExpenseItem(context) {
    return item.expenseItem()
  },
  getEmployee(context) {
    return item.getEmployee()
  },
  getCashAdvance(context, attributes = {}) {
    return item.getCashAdvance({ params: attributes })
  },
  upload(context, data) {
    return item.upload(data)
  },
  toPdf(context, id) {
    return item.toPdf(id)
  },
}